import type { FunctionComponent } from 'react';
import * as styles from './ErrorMessage.module.scss';

type ErrorMessageProps = {
  message: string;
};

const ErrorMessage: FunctionComponent<ErrorMessageProps> = ({ message }) => (
  <div className={styles.container}>{message}</div>
);

export default ErrorMessage;
